import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from '../../config/config.service';

export const homeEnabledGuard: CanActivateFn = () => {
  const homeEnabled = inject(ConfigService).getHomeConfig().enabled;
  if (!homeEnabled) {
    return inject(Router).createUrlTree(['/productos']);
  }
  return true;
};
